// extracted by mini-css-extract-plugin
export default {"CheckboxGroup":"CheckboxGroup_CheckboxGroup__kMBhX","checkboxWrapper":"CheckboxGroup_checkboxWrapper__Iz98b","swing-in":"CheckboxGroup_swing-in__Qc3YE"};